import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import Store from "../../index";
import { api } from "@/lib";

import { UploadAsnRequest } from "@/models/api/asn/upload";
import { IngestAsnResponse } from "@/models/api/asn/ingest";

import { AsnLevel } from "@/models/api/asn/asn";
import { AsnMap, CreateMapRequest } from "@/models/api/asn/map";

import router from '@/router';
import { ProcessAsnRequest, ProcessAsnResponse } from "@/models/api/asn/process";
import { MappableField } from "@/models/api/asn/mappable";
import { AsnImportHistory, AsnImportHistoryResponse } from "@/models/api/asn/history";

@Module({ name: "asn", dynamic: true, store: Store, namespaced: true })
export default class AsnModule extends VuexModule {
  @Action
  async postAsnUpload(payload: UploadAsnRequest) {
    const url = `/asn/upload`;
    const form = new FormData();

    form.append('file', payload.file);
    form.append('asnLevel', payload.asnLevel.toString());
    form.append('hasHeaderRow', payload.hasHeaderRow.toString());

    const response = await api.postAsync(url, form, { headers: { 'Content-Type': 'multipart/form-data' }});
    return response.data;
  }

  @Action
  async getIngestedAsn(uploadId: string) : Promise<IngestAsnResponse> {
    const url = `/asn/ingest?UploadId=${uploadId}`;

    try {
      const response = await api.getAsync(url);
      return response.data;
    }
    catch (error){
      if (error.response.status == 404){
        router.push('/asn/map');
      }
      return;
    }
  }

  @Action
  async getHistory(page: number) : Promise<AsnImportHistoryResponse> {
    const url = `/asn/history?page=${page}&pageSize=20`;
    const response = await api.getAsync(url);
    return response.data;
  }

  @Action
  async previewAsn(request: ProcessAsnRequest) : Promise<ProcessAsnResponse>{
    const url = `/asn/preview`;
    const response = await api.postAsync(url, request);
    return response.data;
  }

  @Action
  async processAsn(request: ProcessAsnRequest) : Promise<ProcessAsnResponse>{
    const url = `/asn/process`;
    const response = await api.postAsync(url, request);
    return response.data;
  }

  @Action
  async getMappableFields(level: AsnLevel) {
    const url = `/asn/mappable?level=${level}`;
    const response = await api.getAsync(url);
    return response.data;
  }

  @Action
  async getMap(mapId: string) : Promise<AsnMap> {
    const url = `/asn/map?id=${mapId}`;
    const response = await api.getAsync(url);
    return response.data;    
  }

  @Action
  async createMap(request: CreateMapRequest) : Promise<AsnMap> {
    const url = `/asn/map/create`;
    const response = await api.postAsync(url, {
      "DisplayName": request.displayName,
      "AsnLevel": request.asnLevel
    });
    return response.data;
  }

  @Action
  async updateMap(map) : Promise<AsnMap> {
    const url = `/asn/map/update`;
    const response = await api.postAsync(url, map);
    return response.data;
  }

  @Action
  async deleteMap(mapId: string) {
    const url = `/asn/map/delete?id=${mapId}`;
    const response = await api.deleteAsync(url);
    return response;
  }

  @Action
  async getMapList() : Promise<AsnMap[]> {
    const url = `/asn/map/list`;
    const response = await api.getAsync(url);
    return response.data;
  }
}
